import getTheme from 'config/themes/base';

const theme = getTheme();

/** Accent for AI Enhancement control and dialog title (icon + label). */
const AI_ENHANCEMENT_COLOR = '#812235';

export default {
  headerSection: {
    width: '100%',
  },
  returnToWinesLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    fontSize: '13px',
    lineHeight: 1.3,
    fontWeight: 500,
    textDecoration: 'none',
    color: theme.palette.primary.sideBarTextColor,
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.text.primary,
    },
  },
  returnToWinesIcon: {
    fontSize: 18,
    color: 'inherit',
  },
  aiEnhancementTrigger: {
    textDecoration: 'underline',
    cursor: 'pointer',
    verticalAlign: 'baseline',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.35,
    border: 0,
    background: 'none',
    padding: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontWeight: 600,
    color: AI_ENHANCEMENT_COLOR,
    marginLeft: '4px',
  },
  aiEnhancementTriggerIcon: {
    fontSize: '1.05em',
    lineHeight: 1,
    color: AI_ENHANCEMENT_COLOR,
  },
  aiDialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    pr: 1,
  },
  aiDialogTitleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    minWidth: 0,
  },
  aiDialogTitleIcon: {
    fontSize: '1.35rem',
    flexShrink: 0,
    color: AI_ENHANCEMENT_COLOR,
  },
  aiDialogTitleText: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: AI_ENHANCEMENT_COLOR,
  },
  modalMailLink: {
    fontWeight: 600,
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  modalTierHeadingFirst: {
    mt: 1.5,
    mb: 0.5,
  },
  modalTierBodyFirst: {
    mb: 1.5,
  },
  modalTierHeading: {
    mb: 0.5,
  },
  modalConfirmation: {
    mt: 2,
  },
};
